export default __webpack_public_path__ + "static/media/AdFlights_02.62130e85.png";